module.exports = __webpack_public_path__ + "img/kykLogo.340599be.png";